<footer class="container footer">
  <h2 class="footer-title">
    {{ 'FOOTER.TITLE' | translate }}
  </h2>

  <div class="footer-content">
    <div class="content-box sm-w-100">
      <app-logo></app-logo>
      <img
        src="assets/icons/digital-gov-logo.svg"
        width="180"
        class="mt-5"
        alt="digital-gov-logo" />
    </div>
    <div class="content-box sm-w-50">
      <ul class="links">
        <li class="link-item">
          <a href="https://waqfy.sa/">
            {{ 'FOOTER.LINKS.WAQFY' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a href="https://awqaf.com.sa/">
            {{ 'FOOTER.LINKS.ENDOWMENT_COMPANY' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a href="https://riyadahawqaf.futurex.sa/">
            {{ 'FOOTER.LINKS.ENDOWMENT_CENTER' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a href="https://www.my.gov.sa/wps/portal/snp/main">
            {{ 'FOOTER.LINKS.UNIFIED_NATIONAL_PLATFORM' | translate }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-box sm-w-47">
      <ul class="links">
        <li class="link-item">
          <a
            [href]="'https://www.awqaf.gov.sa/' + currentLang + '/hiring'"
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.RECRUITMENT' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a
            [href]="
              'https://www.awqaf.gov.sa/' +
              currentLang +
              '/knowledge-center?tab=readable-library'
            "
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.READING_LIBRARY' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a
            [href]="
              'https://www.awqaf.gov.sa/' +
              currentLang +
              '/knowledge-center?tab=visual-library'
            "
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.VISUAL_LIBRARY' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a
            [href]="
              'https://www.awqaf.gov.sa/' +
              currentLang +
              '/media-center?tab=authority-news&page=0'
            "
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.NEWS' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a
            [href]="
              'https://www.awqaf.gov.sa/' +
              currentLang +
              '/competitions-purchases?tab=competitions'
            "
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.COMPETITIONS_PURCHASES' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a
            [href]="'https://www.awqaf.gov.sa/' + currentLang + '/transfers'"
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.TRANSFERS' | translate }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-box sm-w-50">
      <ul class="links">
        <li class="link-item">
          <a [routerLink]="'/contact-us'">
            {{ 'FOOTER.LINKS.CONTACT_US' | translate }}
          </a>
        </li>
        <li class="link-item">
          <a
            [href]="'https://www.awqaf.gov.sa/' + currentLang + '/help-center'"
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.SUGGISTIONS' | translate }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-box sm-w-47">
      <ul class="links">
        <li class="link-item">
          <a
            [href]="
              'https://www.awqaf.gov.sa/' +
              currentLang +
              '/data-services/open-data'
            "
            target="_blank"
            rel="noopener noreferrer">
            {{ 'FOOTER.LINKS.OPEN_DATA' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <footer class="inner-footer">
    <div class="row align-items-center">
      <div class="col-md-9">
        <div class="inner-footer-links-wrapper">
          <ul class="inner-footer-links">
            <li class="inner-footer-link" [dir]="currentDir">
              <a
                [href]="
                  'https://www.awqaf.gov.sa/' + currentLang + '/privacy-policy'
                "
                target="_blank"
                rel="noopener noreferrer">
                {{ 'FOOTER.LINKS.PRIVACY_POLICY' | translate }}
              </a>
            </li>
            <li class="inner-footer-link" [dir]="currentDir">
              <a
                [href]="
                  'https://www.awqaf.gov.sa/' +
                  currentLang +
                  '/terms-conditions'
                "
                target="_blank"
                rel="noopener noreferrer">
                {{ 'FOOTER.LINKS.TERMS_CONDITIONS' | translate }}
              </a>
            </li>
            <li class="inner-footer-link" [dir]="currentDir">
              <a
                [href]="
                  'https://www.awqaf.gov.sa/' + currentLang + '/help-center/faq'
                "
                target="_blank"
                rel="noopener noreferrer">
                {{ 'FOOTER.LINKS.FAQ' | translate }}
              </a>
            </li>
            <li class="inner-footer-link" [dir]="currentDir">
              <a
                [href]="'https://www.awqaf.gov.sa/' + currentLang + '/site-map'"
                target="_blank"
                rel="noopener noreferrer">
                {{ 'FOOTER.LINKS.SITE_MAP' | translate }}
              </a>
            </li>
            <li class="inner-footer-link" [dir]="currentDir">
              <a
                [href]="'https://www.awqaf.gov.sa/' + currentLang + '/sla'"
                target="_blank"
                rel="noopener noreferrer">
                {{ 'FOOTER.LINKS.SERVICE_LEVEL_AGREEMENT' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-md-3">
        <div class="inner-footer-social" [dir]="currentDir">
          <a
            href="https://www.youtube.com/channel/UCFe0ItmV7PXWLrAK63oZ7Jg"
            target="_blank">
            <svg
              width="547"
              height="384"
              viewBox="0 0 547 384"
              fill="#8d8d8d"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M534.722 60.083C528.441 36.433 509.935 17.807 486.438 11.486C443.848 0 273.067 0 273.067 0C273.067 0 102.287 0 59.696 11.486C36.199 17.808 17.693 36.433 11.412 60.083C0 102.95 0 192.388 0 192.388C0 192.388 0 281.826 11.412 324.693C17.693 348.343 36.199 366.193 59.696 372.514C102.287 384 273.067 384 273.067 384C273.067 384 443.847 384 486.438 372.514C509.935 366.193 528.441 348.343 534.722 324.693C546.134 281.826 546.134 192.388 546.134 192.388C546.134 192.388 546.134 102.95 534.722 60.083ZM217.212 273.591V111.185L359.951 192.39L217.212 273.591Z"
                fill="black"></path>
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/company/general-authority-for-awqaf/"
            target="_blank">
            <svg
              width="448"
              height="512"
              viewBox="0 0 448 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100.28 448H7.4V148.9H100.28V448ZM53.79 108.1C24.09 108.1 0 83.4998 0 53.7998C2.1258e-07 39.5338 5.66714 25.8521 15.7547 15.7645C25.8423 5.67691 39.524 0.00976562 53.79 0.00976562C68.056 0.00976562 81.7377 5.67691 91.8253 15.7645C101.913 25.8521 107.58 39.5338 107.58 53.7998C107.58 83.4998 83.48 108.1 53.79 108.1ZM447.9 448H355.22V302.4C355.22 267.7 354.52 223.2 306.93 223.2C258.64 223.2 251.24 260.9 251.24 299.9V448H158.46V148.9H247.54V189.7H248.84C261.24 166.2 291.53 141.4 336.72 141.4C430.72 141.4 448 203.3 448 283.7V448H447.9Z"
                fill="black"></path>
            </svg>
          </a>
          <a href="https://www.instagram.com/awqaf_ksa" target="_blank">
            <svg
              width="448"
              height="512"
              viewBox="0 0 448 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_10120_31069)">
                <path
                  d="M224.1 141C160.5 141 109.2 192.3 109.2 255.9C109.2 319.5 160.5 370.8 224.1 370.8C287.7 370.8 339 319.5 339 255.9C339 192.3 287.7 141 224.1 141ZM224.1 330.6C183 330.6 149.4 297.1 149.4 255.9C149.4 214.7 182.9 181.2 224.1 181.2C265.3 181.2 298.8 214.7 298.8 255.9C298.8 297.1 265.2 330.6 224.1 330.6ZM370.5 136.3C370.5 151.2 358.5 163.1 343.7 163.1C328.8 163.1 316.9 151.1 316.9 136.3C316.9 121.5 328.9 109.5 343.7 109.5C358.5 109.5 370.5 121.5 370.5 136.3ZM446.6 163.5C444.9 127.6 436.7 95.8002 410.4 69.6002C384.2 43.4002 352.4 35.2002 316.5 33.4002C279.5 31.3002 168.6 31.3002 131.6 33.4002C95.8001 35.1002 64 43.3002 37.7001 69.5002C11.4001 95.7002 3.30005 127.5 1.50005 163.4C-0.599951 200.4 -0.599951 311.3 1.50005 348.3C3.20005 384.2 11.4001 416 37.7001 442.2C64 468.4 95.7001 476.6 131.6 478.4C168.6 480.5 279.5 480.5 316.5 478.4C352.4 476.7 384.2 468.5 410.4 442.2C436.6 416 444.8 384.2 446.6 348.3C448.7 311.3 448.7 200.5 446.6 163.5ZM398.8 388C391 407.6 375.9 422.7 356.2 430.6C326.7 442.3 256.7 439.6 224.1 439.6C191.5 439.6 121.4 442.2 92 430.6C72.4 422.8 57.3001 407.7 49.4001 388C37.7001 358.5 40.4001 288.5 40.4001 255.9C40.4001 223.3 37.8001 153.2 49.4001 123.8C57.2001 104.2 72.3 89.1002 92 81.2002C121.5 69.5002 191.5 72.2002 224.1 72.2002C256.7 72.2002 326.8 69.6002 356.2 81.2002C375.8 89.0002 390.9 104.1 398.8 123.8C410.5 153.3 407.8 223.3 407.8 255.9C407.8 288.5 410.5 358.6 398.8 388Z"
                  fill="black"></path>
              </g>
              <defs>
                <clipPath id="clip0_10120_31069">
                  <rect width="448" height="512" fill="white"></rect>
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="https://www.x.com/awqaf_ksa" target="_blank">
            <svg
              width="512"
              height="512"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M389.2 48H459.8L305.6 224.2L487 464H345L233.7 318.6L106.5 464H35.8L200.7 275.5L26.8 48H172.4L272.9 180.9L389.2 48ZM364.4 421.8H403.5L151.1 88H109.1L364.4 421.8Z"
                fill="black"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="inner-footer-wrapper"></div>
  </footer>
</footer>
